import {
  compose, join, map, reduce, startsWith,
} from 'lodash/fp';
import axios from 'axios';
import {
  CLASSTING_API_URL, CLASSTING_EDGE_API_URL, SCHOOL_NEWSLETTER_URL, SLACK_HOOKS_URL,
} from '../common/constants';
import { http } from '../common/utils';

export const sendSMS = ({
  nid, sid, gcids, title,
}) => http.post(`${CLASSTING_API_URL}/v1/schools/${sid}/guardian_contact_newsletters`, {
  guardian_contact_newsletters: map(gcid => ({
    newsletter: { id: nid, title },
    guardian_contact_id: gcid,
  }), gcids),
});

export const resendSMS = ({
  nid, sid, gcids,
}) => http.post(`${CLASSTING_API_URL}/v1/schools/${sid}/resend_newsletter`, {
  guardian_contact_newsletters: map(gcid => ({
    newsletter_id: nid,
    guardian_contact_id: gcid,
  }), gcids),
});

export const sendPushNotificationByUser = ({
  targets, title, content, nid, sid,
}) => http.post(`${CLASSTING_EDGE_API_URL}/push/notifications`, {
  targets: compose(
    acc => (startsWith(',', acc) ? acc.substring(1) : acc),
    reduce((acc, cur) => `${acc},u:${cur}`, ''),
  )(targets),
  headings: { en: title },
  contents: { en: content },
  data: {
    deeplink: `classting://link?url=${encodeURIComponent(
      `${SCHOOL_NEWSLETTER_URL}/school-newsletters?`
        + 'utm_source=school_dashboard'
        + '&utm_medium=push_notification'
        + '&utm_campaign=send_newsletters',
    )}&hide_navi=1`,
    newsletter_id: nid,
    school_id: sid,
  },
});

export const sendAdminRequestNotification = ({
  email, name, jobPosition, school,
}) => axios.post(
  `${SLACK_HOOKS_URL}/services/T025H9BP3/BE4J7PRK3/XxpNaF4gevQ6olKa7cl0KwHl`,
  {
    text: join('', [
      `${name}님이 ${school}의 관리자 권한을 신청하셨습니다.\n`,
      '\n',
      `신청 환경: ${process.env.NODE_ENV === 'production' ? '운영' : '검증'}\n`,
      `신청 학교: ${school}\n`,
      `신청자 이름: ${name}\n`,
      `담당 업무: ${jobPosition}\n`,
      `신청자 이메일: ${email}\n`,
    ]),
  },
  {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'text/plain',
    },
  },
);
